import ThdOverlay from 'thd-overlay';
import Localizer from 'Localizer';
import * as hfConfig from 'hfConfig';

let email = {};
let privateMethods = {};

// Private Methods
// replace this common validation function with one in thdUtils at some point
privateMethods.check = (emailAddress) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(emailAddress);
};

// show/hde the inline error
privateMethods.toggleError = (showError) => {
  const newsletterEmailError = document.getElementById('newsletterEmailError');
  newsletterEmailError?.classList.toggle('u--show', showError);

  const footerEmailSignup = document.querySelector('.footerEmailSignup__controlGroup');
  footerEmailSignup?.classList.toggle('error', showError);
};

privateMethods.getZipCode = () => {
  const localizedStore = Localizer.getLocalizedStore();
  if (localizedStore === undefined) return '00000';
  return localizedStore.zipcode;
},

privateMethods.populateContent = (hasError) => {
  // TODO: Pull out these chunks of markup as templates.
  const errorMsg = `
    We apologize, due to system error, we were
    </br> unable to add your email.
    </br> Please try again later.
  `;
  const successMsg = `
    Thank you for signing up.
    </br>
    Your first email should arrive shortly.
  `;
  let emailOverlayContent = document.createElement('div');
  emailOverlayContent.innerHTML = `
    <div class="footerEmailSignup__signUpMessage--box">
      <div class = "footerEmailSignup__signUpMessage--text">
        ${(hasError ? errorMsg : successMsg)}
      </div>
    </div>
  `;

  let overlayObj = new ThdOverlay({
    speed: '500ms',
    channel: 'desktop',
    useContent: true,
    header: false,
    closeButton: true,
    title: '',
    htmlNode: emailOverlayContent
  });
  overlayObj.open();
};

privateMethods.sendEmail = (emailAddress) => {
  let submitUrlAddress = `https://${hfConfig.secureHostName}/customer/account/v1/guest/preferences`;
  let submitUrl = `${submitUrlAddress}?email=${emailAddress}&zipCode=${privateMethods.getZipCode()}`;

  fetch(submitUrl, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'channelId': '1'
    },
    body: JSON.stringify({ 'preferences': { 'preference': [{ 'isSubscribed': true, 'code': 'PROMOTIONS' }] } }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data?.error) {
        throw new Error(`${data.error}: ${data.message}`)
      } else if (data?.preferences?.status) {
        privateMethods.populateContent(false);
      }
    })
    .catch((error) => privateMethods.populateContent(true));
};

email.handleSubmit = (event) => {
  event.preventDefault();

  let emailInput = document.getElementById('footerEmail').value;
  let isValid = privateMethods.check(emailInput);

  privateMethods.toggleError(!isValid);
  
  if (!isValid) return;
  
  event.target.reset();
  privateMethods.sendEmail(emailInput);
};

email.init = () => document.getElementById('footerEmailSignup')?.addEventListener('submit', email.handleSubmit);

email.getPrivateMethods = () => privateMethods;

export default email;
